import React, { useEffect, useRef } from 'react';
import '../styles/Root.css';
import '../styles/SesCollections.css';
// Import des images
import uniformeLouisXV from '../assets/sescollections/periode1/uniformelouisxv.JPG';
import carte1683 from '../assets/sescollections/periode1/carte1683.jpg';
import sabreOfficier from '../assets/sescollections/periode1/sabreofficier.JPG';
import pistolet1816 from '../assets/sescollections/periode1/pistolet1816.JPG';
import pistoletTromblon from '../assets/sescollections/periode1/pistolettromblon.JPG';
import tambourInfanterie from '../assets/sescollections/periode1/tambourinfanterie.JPG';
import vaisseau74Canons from '../assets/sescollections/periode1/vaisseau74canons.JPG';
import afficheRecrutement from '../assets/sescollections/periode1/afficherecrutement.JPG';
import shakoBodineau from '../assets/sescollections/periode1/shakomarsouinbodineau.jpg';
import sabreMontmorency from '../assets/sescollections/periode1/sabremontmorency.JPG';
import shakoOfficier from '../assets/sescollections/periode2/shakoofficier.JPG';
import shakoGrenadier from '../assets/sescollections/periode2/shakogrenadier.jpg';
import shakoGrenadier2 from '../assets/sescollections/periode2/shakogrenadier2.JPG';
import shakoIMA from '../assets/sescollections/periode2/shakoima.JPG';
import soldat1845 from '../assets/sescollections/periode2/soldat1845.JPG';
import giberneOfficier from '../assets/sescollections/periode2/giberneofficier.JPG';
import tonneletCantiniere from '../assets/sescollections/periode2/tonnelet2ndempire.jpg';
import bronzeAubert from '../assets/sescollections/periode2/bronzeaubert.jpg';
import assietteTuyenQuan from '../assets/sescollections/periode2/assietetuyenquan.jpg';
import bicorneGarnier from '../assets/sescollections/periode2/bicornegarnier.jpg';
import bicorneGentil from '../assets/sescollections/periode2/bicornegentil.jpg';
import dolmanMarchand from '../assets/sescollections/periode2/dolmanmarchand.png';
import chefDeBataillon from '../assets/sescollections/periode2/chefdebataillon.JPG';
import kepiFiegenschuh from '../assets/sescollections/periode3/kepifiegenschuh.jpg';
import kepiMangin from '../assets/sescollections/periode3/kepimangin.jpg';
import casqueLargeau from '../assets/sescollections/periode3/casquelargeau.jpg';
import cravate24RIC from '../assets/sescollections/periode3/cravate24ric.jpg';
import casqueAllemand from '../assets/sescollections/periode3/casqueallemand.jpg';
import claironCameroun from '../assets/sescollections/periode3/claironcameroun.jpg';
import corAgades from '../assets/sescollections/periode3/coragades.jpg';
import casqueVanwaetermeulen from '../assets/sescollections/periode3/casquewanwaetermeulen.jpg';
import brassardDelayen from '../assets/sescollections/periode3/brassarddelayen.jpg';
import casqueSpahis from '../assets/sescollections/periode3/casquespahis.jpg';
import fanion17RTS from '../assets/sescollections/periode3/fanion17rts.jpg';
import casqueBritannique from '../assets/sescollections/periode3/casquebritannique.jpg';
import afficheExposition from '../assets/sescollections/periode3/expocoloniale.jpg';
import baigneurNoir from '../assets/sescollections/periode3/baigneurnoir.jpg';
import expoMarseille from '../assets/sescollections/periode3/expomarseille.JPG';
import fanionChari from '../assets/sescollections/periode3/fanionchari.JPG';
import mas38 from '../assets/sescollections/periode3/mas38.jpg';
import sten1942 from '../assets/sescollections/periode3/sten1942.jpg';
import m11941 from '../assets/sescollections/periode3/m11941.jpg';
import fanion9DIC from '../assets/sescollections/periode3/fanion9dic.jpg';
import fanion1DFL from '../assets/sescollections/periode3/fanion1dfl.JPG';
import fanionLeclerc from '../assets/sescollections/periode3/fanionleclerc.jpg';
import vedetteBlindée from '../assets/sescollections/periode4/vedetteblindeericm.jpg';
import pistoletNambu from '../assets/sescollections/periode4/pistoletnambu.jpg';
import chapeauGurka from '../assets/sescollections/periode4/chapeaugurkabrit.jpg';
import fanionCommandosViet from '../assets/sescollections/periode4/fanioncommandosviet.jpg';
import tenueForray from '../assets/sescollections/periode4/tenueltforray.jpg';
import cameraSchoendoerffer from '../assets/sescollections/periode4/cameraschoendoerffer.jpg';
import vesteSalan from '../assets/sescollections/periode4/vestesalan.JPG';
import drapeauParaOE from '../assets/sescollections/periode4/drapeauparaoe.JPG';
import fanion6RIAOM from '../assets/sescollections/periode4/fanion6riaom.JPG';
import fanionCPIMa from '../assets/sescollections/periode4/fanioncpima.JPG';
import casqueONU from '../assets/sescollections/periode4/casqueonu.JPG';
import limousin1969 from '../assets/sescollections/periode5/1969limousin.jpg';
import limousinRadio from '../assets/sescollections/periode5/limousinradio.jpg';
import limousinTchad from '../assets/sescollections/periode5/limousintchad.jpg';
import tchad1969 from '../assets/sescollections/periode5/tchad.png';
import heliportage1970 from '../assets/sescollections/periode5/1970.png';
import tacaud1978 from '../assets/sescollections/periode5/tacaud78.jpg';
import larteguy1983 from '../assets/sescollections/periode5/larteguyserpol.jpg';
import beyrouth1983 from '../assets/sescollections/periode5/beyrouth1983.jpg';
import bigeard1983 from '../assets/sescollections/periode5/bigeardurwald.jpg';
import fmsb1983 from '../assets/sescollections/periode5/fmsb.jpg';
import fmsb1984 from '../assets/sescollections/periode5/fmsb2.jpg';
import manta1984 from '../assets/sescollections/periode5/manta1984.jpg';
import daguet1991 from '../assets/sescollections/periode5/daguet.jpg';
import daguet1991_2 from '../assets/sescollections/periode5/daguet2.jpg';
import yougoslavie1992 from '../assets/sescollections/periode5/yougoslavie.jpg';
import turquoise1994 from '../assets/sescollections/periode5/evacuation.jpg';
import lafourcade1994 from '../assets/sescollections/periode5/lafourcade.jpg';
import posteTir1994 from '../assets/sescollections/periode5/postedetir.jpg';
import antichar1994 from '../assets/sescollections/periode5/antichar.jpg';
import turquoise1994_2 from '../assets/sescollections/periode5/turquoise.jpg';
import afghanistan2011 from '../assets/sescollections/periode5/afghanistan2011.jpg';
import serval2013 from '../assets/sescollections/periode5/serval2013.jpg';
import serval2013_2 from '../assets/sescollections/periode5/serval2013_2.jpg';
import soldat2015 from '../assets/sescollections/periode5/2015.jpg';
import mehariste1931 from '../assets/sescollections/Méharistes/Vignette Thème - Les Méharistes, le Lieutenant Boéry en 1931.PNG';
import santeEmpire from '../assets/sescollections/Santé/servicesante.jpg';
// Import de la vidéo
import videoSesCollections from '../assets/videosmusee/sescollections.mp4';

const GallerySection = ({ title, description, children }) => {
  const galleryRef = useRef(null);
  const leftArrowRef = useRef(null);
  const rightArrowRef = useRef(null);

  useEffect(() => {
    const handleArrowClick = (direction) => {
      const galleryGrid = galleryRef.current;
      if (galleryGrid) {
        galleryGrid.scrollBy({
          left: direction === 'right' ? galleryGrid.offsetWidth : -galleryGrid.offsetWidth,
          behavior: 'smooth'
        });
      }
    };

    const leftArrow = leftArrowRef.current;
    const rightArrow = rightArrowRef.current;

    if (leftArrow && rightArrow) {
      leftArrow.addEventListener('click', () => handleArrowClick('left'));
      rightArrow.addEventListener('click', () => handleArrowClick('right'));
    }

    return () => {
      if (leftArrow && rightArrow) {
        leftArrow.removeEventListener('click', () => handleArrowClick('left'));
        rightArrow.removeEventListener('click', () => handleArrowClick('right'));
      }
    };
  }, []);

  return (
    <section className="gallery-section fade-in">
      <h2>{title}</h2>
      <p>{description}</p>
      <div className="gallery-grid-container">
        <button className="arrow left-arrow" ref={leftArrowRef}>&#10094;</button>
        <div className="gallery-grid" ref={galleryRef}>
          {children}
        </div>
        <button className="arrow right-arrow" ref={rightArrowRef}>&#10095;</button>
      </div>
      <a href="/pages/InformationsPratiques" className="btn btn-primary">Visiter le musée</a>
    </section>
  );
};

const Collections = () => {
  useEffect(() => {
    const fadeElements = document.querySelectorAll('.fade-in');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = 1;
        }
      });
    }, {
      threshold: 0.1
    });
    fadeElements.forEach(element => {
      observer.observe(element);
    });
  }, []);

  return (
    <main>
      <section className="hero fade-in">
        <h1>Ses Collections</h1>
        <p>Découvrez les collections du Musée des Troupes de Marine</p>
      </section>
      <section className="content-section fade-in">
        <h2>Introduction</h2>
        <p>Le Musée des Troupes de Marine abrite une collection riche et variée d'objets historiques, de documents, et d'œuvres d'art qui témoignent de l'histoire des troupes de marine et de l'armée de terre. Ces collections sont soigneusement conservées et présentées pour offrir aux visiteurs une expérience immersive et éducative.</p>
      </section>
      <section className="video-container fade-in">
        <figure>
          <video className="video-border" controls>
            <source src={videoSesCollections} type="video/mp4" />
            Votre navigateur ne supporte pas la lecture de vidéos.
          </video>
          <figcaption className="video-caption">Le lieutenant (F) Mangin, Conservatrice du Musée des Troupes de Marine, nous parle de ses collections.</figcaption>
        </figure>
      </section>

      <GallerySection
        title="1622 - 1830 : À la découverte de nouveaux mondes"
        description="Cette partie évoque le premier empire colonial français et sa perte progressive. Les dates suivantes sont mises en relief : 1763, perte de la Nouvelle France et de l’Inde lors du Traité de Paris ; 1815, restitution des colonies perdues (Antilles et Mascareignes pendant les guerres de la Révolution et de l’Empire) ; 1830, avènement de la Monarchie de Juillet et changement de la politique coloniale de la France."
      >
        <div className="gallery-item">
          <img className="img-feature" src={uniformeLouisXV} alt="Uniforme Période Louis XV" />
          <div className="description">Uniforme Période Louis XV</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={carte1683} alt="Carte de l'empire colonial dressée en 1683" />
          <div className="description">Carte de l'empire colonial dressée en 1683</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={sabreOfficier} alt="Sabre d'officier d'artillerie de marine 1769-1772" />
          <div className="description">Sabre d'officier d'artillerie de marine 1769-1772</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={pistolet1816} alt="Pistolet de marine modèle 1816" />
          <div className="description">Pistolet de marine modèle 1816</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={pistoletTromblon} alt="Pistolet tromblon de marine époque Louis XVI" />
          <div className="description">Pistolet tromblon de marine époque Louis XVI</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={tambourInfanterie} alt="Tambour d'infanterie de l'époque 1793-1800" />
          <div className="description">Tambour d'infanterie de l'époque 1793-1800</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={vaisseau74Canons} alt="Vaisseau 74 canons" />
          <div className="description">Vaisseau 74 canons</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={afficheRecrutement} alt="Affiche de recrutement 1816" />
          <div className="description">Affiche de recrutement 1816</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={shakoBodineau} alt="Shako du marsouin Bodineau du 1 RIM entre 1822 et 1827" />
          <div className="description">Shako du marsouin Bodineau du 1 RIM entre 1822 et 1827</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={sabreMontmorency} alt="Petit sabre dit Montmorency" />
          <div className="description">Petit sabre dit Montmorency</div>
        </div>
      </GallerySection>

      <GallerySection
        title="1830 - 1900 : Les Troupes de marine à la conquête du monde"
        description="Cette partie couvre l'établissement quasi définitif des frontières du second empire colonial et le passage des Troupes de marine sous la tutelle du ministère de la Guerre, sous le nom de « Troupes coloniales ». Une attention particulière est portée à la guerre franco-prussienne et aux combats de Bazeilles. Les campagnes du Second Empire, notamment en Crimée et au Mexique, sont également évoquées. Les conquêtes de « l’Afrique noire », de Madagascar et de l’Indochine, ainsi que la création des unités de tirailleurs indigènes, sont des points clés de cette période."
      >
        <div className="gallery-item">
          <img className="img-feature" src={shakoOfficier} alt="Shako d'officier d'infanterie de marine 1831 - 1837" />
          <div className="description">Shako d'officier d'infanterie de marine 1831 - 1837</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={shakoGrenadier} alt="Shako de grenadier d'infanterie de marine 1845 - 1848" />
          <div className="description">Shako de grenadier d'infanterie de marine 1845 - 1848</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={shakoGrenadier2} alt="Shako de grenadier de la Monarchie de Juillet 1845 - 1848" />
          <div className="description">Shako de grenadier de la Monarchie de Juillet 1845 - 1848</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={shakoIMA} alt="Shako troupe infanterie de marine 1845" />
          <div className="description">Shako troupe infanterie de marine 1845</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={soldat1845} alt="Soldat infanterie de marine 1845 - Huile sur bois" />
          <div className="description">Soldat infanterie de marine 1845 - Huile sur bois</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={giberneOfficier} alt="Giberne d'officier supérieur d'artillerie de marine" />
          <div className="description">Giberne d'officier supérieur d'artillerie de marine</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={tonneletCantiniere} alt="Tonnelet de cantinière - Second Empire" />
          <div className="description">Tonnelet de cantinière - Second Empire</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={bronzeAubert} alt="Bronze d'Anfrie Capitaine Aubert" />
          <div className="description">Bronze d'Anfrie Capitaine Aubert</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={assietteTuyenQuan} alt="Assiette - Siège de Tuyen Quan" />
          <div className="description">Assiette - Siège de Tuyen Quan</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={bicorneGarnier} alt="Bicorne d'officier de marine de Francis Garnier 1866 - 1873" />
          <div className="description">Bicorne d'officier de marine de Francis Garnier 1866 - 1873</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={bicorneGentil} alt="Bicorne du Gouverneur général d'Emile Gentil" />
          <div className="description">Bicorne du Gouverneur général d'Emile Gentil</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={dolmanMarchand} alt="Dolman du Capitaine Marchand 1896" />
          <div className="description">Dolman du Capitaine Marchand 1896</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={chefDeBataillon} alt="Portrait de Chef de Bataillon d'Infanterie de marine - IIIe Rép." />
          <div className="description">Portrait de Chef de Bataillon d'Infanterie de marine - IIIe Rép.</div>
        </div>
      </GallerySection>

      <GallerySection
        title="1900 - 1945 : Garder l’Empire et défendre la France"
        description="Cette partie aborde les campagnes en Mauritanie, au Niger, au Soudan (Mali) et au Tchad de 1900 à 1914. La Première Guerre mondiale est explorée à travers les faits d’armes des troupes coloniales et indigènes. La période 1919-1939 se concentre sur les campagnes de Cilicie, du Liban et du Maroc. La Deuxième Guerre mondiale met en lumière les troupes coloniales et indigènes, notamment pendant les campagnes de la Libération et singulièrement lors du débarquement, puis au cours de la libération de la Provence."
      >
        <div className="gallery-item">
          <img className="img-feature" src={kepiFiegenschuh} alt="Képi du Capitaine Fiegenschuh tué en 1910 au Darfour" />
          <div className="description">Képi du Capitaine Fiegenschuh tué en 1910 au Darfour</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={kepiMangin} alt="Képi du Colonel Mangin entre 1910 et 1913" />
          <div className="description">Képi du Colonel Mangin entre 1910 et 1913</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={casqueLargeau} alt="Casque Adrian du général Largeau tué en 1916" />
          <div className="description">Casque Adrian du général Largeau tué en 1916</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={cravate24RIC} alt="Cravate de drapeau du 24 RIC" />
          <div className="description">Cravate de drapeau du 24 RIC</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={casqueAllemand} alt="Casque allemand en acier distribué en 1916" />
          <div className="description">Casque allemand en acier distribué en 1916</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={claironCameroun} alt="Clairon de l'armée allemande pris au Cameroun" />
          <div className="description">Clairon de l'armée allemande pris au Cameroun</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={corAgades} alt="Cor saisi aux touaregs à Agadès en 1917" />
          <div className="description">Cor saisi aux touaregs à Agadès en 1917</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={casqueVanwaetermeulen} alt="Casque du général Vanwaetermeulen tué en 1918" />
          <div className="description">Casque du général Vanwaetermeulen tué en 1918</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={brassardDelayen} alt="Brassard de l'Etat-major de Lyautey - Capitaine Delayen" />
          <div className="description">Brassard de l'Etat-major de Lyautey - Capitaine Delayen</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={casqueSpahis} alt="Casque de Spahis sénégalais" />
          <div className="description">Casque de Spahis sénégalais</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={fanion17RTS} alt="Fanion du 17e RTS" />
          <div className="description">Fanion du 17e RTS</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={casqueBritannique} alt="Casque colonial britannique - FFL septembre 1940" />
          <div className="description">Casque colonial britannique - FFL septembre 1940</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={afficheExposition} alt="Affiche Exposition coloniale" />
          <div className="description">Affiche Exposition coloniale</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={baigneurNoir} alt="Baigneur noir vendu pendant l'exposition de 1931" />
          <div className="description">Baigneur noir vendu pendant l'exposition de 1931</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={expoMarseille} alt="Exposition de Marseille" />
          <div className="description">Exposition de Marseille</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={fanionChari} alt="Fanion de l'Oubangui Chari 1939-1945" />
          <div className="description">Fanion de l'Oubangui Chari 1939-1945</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={mas38} alt="Pistolet mitrailleur MAS 38" />
          <div className="description">Pistolet mitrailleur MAS 38</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={sten1942} alt="Pistolet mitrailleur Sten 1942" />
          <div className="description">Pistolet mitrailleur Sten 1942</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={m11941} alt="Casques américains modèle M1 de 1941" />
          <div className="description">Casques américains modèle M1 de 1941</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={fanion9DIC} alt="Fanion de commandement du Général Magnan - 9 DIC" />
          <div className="description">Fanion de commandement du Général Magnan - 9 DIC</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={fanion1DFL} alt="Fanion du 24 Bataillon de Marche - 1 DFL" />
          <div className="description">Fanion du 24 Bataillon de Marche - 1 DFL</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={fanionLeclerc} alt="Fanion du char du Général Leclerc" />
          <div className="description">Fanion du char du Général Leclerc</div>
        </div>
      </GallerySection>

      <GallerySection
        title="1945 - 1962 : La fin d’un Empire"
        description="Cette partie correspond aux deux guerres de décolonisation d’Indochine et d’Algérie. Sont évoqués : le coup de force japonais en Indochine de 1945, la guerre de Corée, l’expédition de Suez et la création et le rôle des unités parachutistes."
      >
        <div className="gallery-item">
          <img className="img-feature" src={vedetteBlindée} alt="Maquette d'une vedette blindée du RICM 1950-1954" />
          <div className="description">Maquette d'une vedette blindée du RICM 1950-1954</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={pistoletNambu} alt="Pistolet japonais Nambu" />
          <div className="description">Pistolet japonais Nambu</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={chapeauGurka} alt="Chapeau de Gurka de l'armée britannique" />
          <div className="description">Chapeau de Gurka de l'armée britannique</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={fanionCommandosViet} alt="Fanion des commandos Nord Vietnam" />
          <div className="description">Fanion des commandos Nord Vietnam</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={tenueForray} alt="Tenue commando Nord Vietnam du Lieutenant Forray" />
          <div className="description">Tenue commando Nord Vietnam du Lieutenant Forray</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={cameraSchoendoerffer} alt="Caméra Paillard de Pierre Schoendoerffer" />
          <div className="description">Caméra Paillard de Pierre Schoendoerffer</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={vesteSalan} alt="Veste du général Raoul Salan" />
          <div className="description">Veste du général Raoul Salan</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={drapeauParaOE} alt="Réplique du drapeau de la Brigade parachutiste d'Outre-mer" />
          <div className="description">Réplique du drapeau de la Brigade parachutiste d'Outre-mer</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={fanion6RIAOM} alt="Fanion de la compagnie motorisée du 6 RIAOM (Tchad)" />
          <div className="description">Fanion de la compagnie motorisée du 6 RIAOM (Tchad)</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={fanionCPIMa} alt="Fanion de la CPIMa" />
          <div className="description">Fanion de la CPIMa</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={casqueONU} alt="Casque Mle F1 aux couleurs de l'ONU" />
          <div className="description">Casque Mle F1 aux couleurs de l'ONU</div>
        </div>
      </GallerySection>

      <GallerySection
        title="De 1962 à nos jours : Le temps de la coopération et des opérations extérieures"
        description="Cette gallerie de photographies évoque la coopération militaire avec les nouveaux États indépendants, l’apparition du Service Militaire Adapté et la coopération avec les États africains, sous leurs formes successives (de l’assistance militaire technique au partenariat militaire opérationnel). Les interventions militaires sous mandat international et les nombreuses opérations extérieures dans lesquelles les Troupes de marine ont été engagées occupent une place essentielle. Ces OPEX sont présentées selon une logique géographique. Certaines, comme les interventions au Tchad ou celles au Liban, s’étalent sur 50 ans, et couvrent donc la quasi-totalité de la période présentée. Les guerres du Koweït, d’ex-Yougoslavie et d’Afghanistan occupent une place de choix, à côté des interventions au Cambodge, en Somalie, au Rwanda, en Côte d’Ivoire, en République centrafricaine, et bien entendu des engagements plus récents (opérations Serval et Barkhane au Sahel)."
      >
        <div className="gallery-item">
          <img className="img-feature" src={limousin1969} style={{ objectFit: 'cover', position: 'top' }} alt="1969 - Limousin, Tchad, Ferret et jeep" />
          <div className="description">1969 - Limousin, Tchad, Ferret et jeep</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={limousinRadio} style={{ objectFit: 'cover' }} alt="1969 - Limousin, Tchad, le Radio" />
          <div className="description">1969 - Limousin, Tchad, le radio</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={limousinTchad} style={{ objectFit: 'cover' }} alt="1969 - Limousin, Tchad" />
          <div className="description">1969 - Limousin, Tchad</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={tchad1969} style={{ objectFit: 'cover', position: 'top' }} alt="1969-72 - Tchad" />
          <div className="description">1969-72 - Tchad</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={heliportage1970} alt="1970 - Heliportage" />
          <div className="description">1970 - Heliportage</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={tacaud1978} alt="1978 - Tacaud, Tchad" />
          <div className="description">1978 - Tacaud, Tchad</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={larteguy1983} alt="1983 - Beyrouth, Lartéguy, Colonel SERPOL et son radio" />
          <div className="description">1983 - Beyrouth, Lartéguy, Colonel SERPOL et son radio</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={beyrouth1983} alt="1983 - Beyrouth" />
          <div className="description">1983 - Beyrouth</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={bigeard1983} alt="1983 - Bigeard sur les ruines de Drakkar, Colonel Urwald et son second" />
          <div className="description">1983 - Bigeard sur les ruines de Drakkar, Colonel Urwald et son second</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={fmsb1983} alt="1983 - FMSB, Beyrouth, Liban, le Drakkar" />
          <div className="description">1983 - FMSB, Beyrouth, Liban, le Drakkar</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={fmsb1984} style={{ objectFit: 'cover' }} alt="1984 - FMSB, Beyrouth, Liban" />
          <div className="description">1984 - FMSB, Beyrouth, Liban</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={manta1984} alt="1984 - Manta, Tchad" />
          <div className="description">1984 - Manta, Tchad</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={daguet1991} alt="1991 - Daguet, Irak, Appui feu section de mortiers lourds" />
          <div className="description">1991 - Daguet, Irak, Appui feu section de mortiers lourds</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={daguet1991_2} alt="1991 - Daguet, Irak" />
          <div className="description">1991 - Daguet, Irak</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={yougoslavie1992} style={{ objectFit: 'cover' }} alt="1992 - Ex Yougoslavie" />
          <div className="description">1992 - Ex Yougoslavie</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={turquoise1994} alt="1994 - Turquoise, Rwanda, évacuation de ressortissants" />
          <div className="description">1994 - Turquoise, Rwanda, évacuation de ressortissants</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={lafourcade1994} alt="1994 - Turquoise, Rwanda, Général Lafourcade" />
          <div className="description">1994 - Turquoise, Rwanda, Général Lafourcade</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={posteTir1994} alt="1994 - Turquoise, Rwanda, poste de tir Milan" />
          <div className="description">1994 - Turquoise, Rwanda, poste de tir Milan</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={antichar1994} style={{ objectFit: 'cover' }} alt="1994 - Turquoise, Rwanda, tireur anti-char" />
          <div className="description">1994 - Turquoise, Rwanda, tireur anti-char</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={turquoise1994_2} style={{ objectFit: 'cover' }} alt="1994 - Turquoise, Rwanda" />
          <div className="description">1994 - Turquoise, Rwanda</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={afghanistan2011} alt="2011 - Afghanistan" />
          <div className="description">2011 - Afghanistan</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={serval2013} alt="2013 - Serval, mali, sentinelle" />
          <div className="description">2013 - Serval, mali, sentinelle</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={serval2013_2} alt="2013 - Serval, Mali" />
          <div className="description">2013 - Serval, Mali</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={soldat2015} style={{ objectFit: 'cover' }} alt="2015 - soldat français" />
          <div className="description">2015 - soldat français</div>
        </div>
      </GallerySection>

      <GallerySection
        title="Thématiques"
        description="Les collections d’insignes et de décorations, importantes, sont présentées dans un « cabinet de curiosité »."
      >
        <div className="gallery-item">
          <img className="img-feature" src={mehariste1931} style={{ objectFit: 'cover', position: 'top' }} alt="1931 - Les Méharistes, le Lieutenant Boéry" />
          <div className="description">1931 - Les Méharistes, le Lieutenant Boéry</div>
        </div>
        <div className="gallery-item">
          <img className="img-feature" src={santeEmpire} style={{ objectFit: 'cover', position: 'top' }} alt="Service de santé de l'Empire" />
          <div className="description">Service de santé de l'Empire</div>
        </div>
      </GallerySection>
    </main>
  );
};

export default Collections;
